@use "~theme/typographyV2.scss";
@use "./tokens";

.label {
  display: block;
  cursor: pointer;
  user-select: none;
  background-color: var(--white);
  max-width: var(--max-desktop-width);
  border: 1px solid transparent;
  padding: 8px 0;

  &:focus-within {
    border-color: var(--blue-02);
  }
}

.heading {
  @include typographyV2.heading4;
  display: block;
  margin-left: tokens.$checkbox-width;
  margin-bottom: 8px;
  color: var(--blue-01);
  font-family: typographyV2.$font-mont;
  font-size: 1rem;
}

.content {
  display: flex;
  min-width: 0;
}

.checkmarkContainer {
  display: inline-flex;
  justify-content: center;
  width: tokens.$checkbox-width;
  flex-shrink: 0;
}

.description {
  @include typographyV2.body;
  color: var(--black);
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
